
import router from '@/router';

import { Product } from '@/definitions/definitions';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { isCartBlockedSession } from '@/utils/roles';

import CPFetchingOverlay from '@/components/globals/CPFetchingOverlay.vue';
import CPLoader from '@/components/globals/CPLoader.vue';
import { Product } from '@/definitions/definitions';

import CPWatchlistEdit from '@/components/globals/CPWatchlistEdit.vue';

@Component({
  components: {
    CPFetchingOverlay,
    CPLoader,
    CPWatchlistEdit,
  },
})
export default class CPWatchlist extends Vue {

  public get watchlist(): Product[] {
    return this.$store.state.watchlist.watchlist;
  }

  public get watchlistEdit() {
    return this.$store.state.watchlist.editWatchlist;
  }

  public get fetching() {
    return this.$store.state.watchlist.fetching;
  }
  public get activeAccountId() {
    return this.$store.state.account.details.activeAccountId;
  }

  public editWatchlist(watchlist: any) {
    this.$store.commit('setEditWatchlist', watchlist);
  }

  @Watch('activeAccountId')
  public updateWatchlist() {
    this.$store.dispatch('getWatchlist');
  }

  public showFactSheet(product: Product) {
    this.$store.dispatch('getFundDetails', product);
  }

  public showFundSummary(fund: any) {
    this.$store.dispatch('getFundSummary', fund);
  }

  public buyItem(result: any) {
    if (isCartBlockedSession(this.$store.state.account.details)) {
      this.$store.dispatch('addError', 'Buy feature is not available, Please login as the client to continue with buy/sell process');
    } else {
      this.$store.dispatch('updateBuyBasketDetails', result);
      this.$store.commit('toggleBuyBasket', true);
    }
  }

  public goToClientList() {
    // @ts-ignore - tell typscript to ignore this line as history is a private api and therefore doesnt appear on the typings
    if (router.history.current.name !== 'my-account') {
      router.push('/my-account');
    }
    setTimeout(() => {
      const el = document.getElementsByClassName('cp-client-directory')[0];
      this.$store.dispatch('scrollToActiveSection', el);
    }, 800);
    this.$store.commit('updateFocusElement', 'client-list');
    this.close();
  }

  public remove(item: any) {
    this.$store.dispatch('removeFromWatchlist', item);
  }

  public close() {
    this.editWatchlist(null);
    this.$store.commit('toggleWatchlist', false);
  }

  public mounted() {
    this.$store.dispatch('getWatchlist');
  }
}
